import contentFirstAid from "../content.json";
import contentHygiene1 from "../contentHygiene1.json";
import contentHygiene2 from "../contentHygiene2.json";
import contentHygiene2En from "../contentHygiene2-en.json";
import contentHygiene3 from "../contentHygiene3.json";
import contentHygiene4 from "../contentHygiene4.json";
import contentHygieneH10 from "../contentHygieneh10.json";
import contentHygieneH10En from "../contentHygieneh10-en.json";
import contentHygieneH11 from "../contentHygieneh11.json";
import contentHygieneH12 from "../contentHygieneh12.json";
import contentHygieneH13 from "../contentHygieneh13.json";
import contentHygieneH14 from "../contentHygieneh14.json";
import contentHygieneH15 from "../contentHygieneh15.json";
import contentHygieneH2 from "../contentHygieneh2.json";
import contentHygieneH3 from "../contentHygieneh3.json";
import contentHygieneH4 from "../contentHygieneh4.json";
import contentHygieneH5 from "../contentHygieneh5.json";
import contentHygieneH6 from "../contentHygieneh6.json";
import contentHygieneH7 from "../contentHygieneh7.json";
import contentHygieneH9 from "../contentHygieneh9.json";
import contentHygieneHb from "../contentHygienehb.json";
import contentHygieneHbEn from "../contentHygienehb-en.json";
import contentHygieneHbb from "../contentHygienehbb.json";
import questionsFirstAid from "../questions.json";
import questionsHygiene1 from "../questionsHygiene1.json";
import questionsHygiene2 from "../questionsHygiene2.json";
import questionsHygiene2En from "../questionsHygiene2-en.json";
import questionsHygiene3 from "../questionsHygiene3.json";
import questionsHygiene4 from "../questionsHygiene4.json";
import questionsHygieneH10 from "../questionsHygieneh10.json";
import questionsHygieneH10En from "../questionsHygieneh10-en.json";
import questionsHygieneH11 from "../questionsHygieneh11.json";
import questionsHygieneH12 from "../questionsHygieneh12.json";
import questionsHygieneH13 from "../questionsHygieneh13.json";
import questionsHygieneH14 from "../questionsHygieneh14.json";
import questionsHygieneH15 from "../questionsHygieneh15.json";
import questionsHygieneH2 from "../questionsHygieneh2.json";
import questionsHygieneH3 from "../questionsHygieneh3.json";
import questionsHygieneH4 from "../questionsHygieneh4.json";
import questionsHygieneH5 from "../questionsHygieneh5.json";
import questionsHygieneH6 from "../questionsHygieneh6.json";
import questionsHygieneH7 from "../questionsHygieneh7.json";
import questionsHygieneH9 from "../questionsHygieneh9.json";
import questionsHygieneHb from "../questionsHygienehb.json";
import questionsHygieneHbEn from "../questionsHygienehb-en.json";
import questionsHygieneHbb from "../questionsHygienehbb.json";

export const ROLE_NAMESPACE = "https://mokymai.firstaid.lt/roles";
export const DEFAULT_PRODUCT_KEY = "firstaid";
export const HB_FIELD_CODE_OPTIONS = [
  "007",
  "008",
  "009",
  "010",
  "011",
  "013",
  "016",
  "017",
  "019",
  "021",
  "022",
  "023",
  "024",
] as const;

interface CertificateConfig {
  fieldCode: string;
  productCode: string;
  hours: string;
  templatePath?: "/certificate.pdf" | "/certificatehb.pdf";
}

export interface ProductDefinition {
  title: string;
  material: unknown;
  questions: unknown;
  isEnglish?: boolean;
  certificate?: CertificateConfig;
}

export const PRODUCT_REGISTRY = {
  firstaid: {
    title: "Pirmosios pagalbos mokymai",
    material: contentFirstAid,
    questions: questionsFirstAid,
  },
  hygiene4: {
    title: "Higienos mokymai (H1) Vaikų poilsio stovyklų, vaikų žaidimų patalpų darbuotojams",
    material: contentHygiene4,
    questions: questionsHygiene4,
    certificate: { fieldCode: "017", productCode: "H1", hours: "6 a.k." },
  },
  hygiene3: {
    title:
      "Higienos mokymai (H1) Švietimo įstaigų darbuotojams – vaikų globos įstaigų darbuotojams",
    material: contentHygiene3,
    questions: questionsHygiene3,
    certificate: { fieldCode: "007", productCode: "H1", hours: "6 a.k." },
  },
  hygiene1: {
    title:
      "Higienos mokymai (H1) Švietimo įstaigų darbuotojams – ikimokyklinių įstaigų darbuotojams",
    material: contentHygiene1,
    questions: questionsHygiene1,
    certificate: { fieldCode: "007", productCode: "H1", hours: "6 a.k." },
  },
  hygiene2: {
    title: "Higienos mokymai (H1) Švietimo įstaigų darbuotojams – mokyklų darbuotojams",
    material: contentHygiene2,
    questions: questionsHygiene2,
    certificate: { fieldCode: "007", productCode: "H1", hours: "6 a.k." },
  },
  hygiene2en: {
    title: "Hygiene training (H1) Training for school staff",
    material: contentHygiene2En,
    questions: questionsHygiene2En,
    isEnglish: true,
    certificate: { fieldCode: "007", productCode: "H1", hours: "6 a.k." },
  },
  hygieneh2: {
    title: "Higienos mokymai (H2) Socialiniams darbuotojams, dirbantiems su suaugusiais asmenimis",
    material: contentHygieneH2,
    questions: questionsHygieneH2,
    certificate: { fieldCode: "008", productCode: "H2", hours: "6 a.k." },
  },
  hygieneh3: {
    title: "Higienos mokymai (H3) Grožio paslaugas teikiantiems darbuotojams",
    material: contentHygieneH3,
    questions: questionsHygieneH3,
    certificate: { fieldCode: "009", productCode: "H3", hours: "6 a.k." },
  },
  hygieneh4: {
    title: "Higienos mokymai (H4) Soliariumų paslaugas teikiantys darbuotojai",
    material: contentHygieneH4,
    questions: questionsHygieneH4,
    certificate: { fieldCode: "010", productCode: "H4", hours: "6 a.k." },
  },
  hygieneh5: {
    title:
      "Higienos mokymai (H5) Sporto klubų, baseinų, pirčių, sveikatingumo paslaugas teikiantiems darbuotojams",
    material: contentHygieneH5,
    questions: questionsHygieneH5,
    certificate: { fieldCode: "011", productCode: "H5", hours: "6 a.k." },
  },
  hygieneh6: {
    title: "Higienos mokymai (H6) Apgyvendinimo paslaugas teikiantiems darbuotojams",
    material: contentHygieneH6,
    questions: questionsHygieneH6,
    certificate: { fieldCode: "013", productCode: "H6", hours: "6 a.k." },
  },
  hygieneh7: {
    title: "Higienos mokymai (H7) Skirta keleivinio transporto darbuotojams",
    material: contentHygieneH7,
    questions: questionsHygieneH7,
    certificate: { fieldCode: "016", productCode: "H7", hours: "6 a.k." },
  },
  hygieneh9: {
    title: "Higienos mokymai (H9) Vandens tiekimo įmonių darbuotojams bei jų vadovams",
    material: contentHygieneH9,
    questions: questionsHygieneH9,
    certificate: { fieldCode: "019", productCode: "H9", hours: "5 a.k." },
  },
  hygieneh10: {
    title: "Higienos mokymai (H10) Tiesiogiai maistą tvarkantiems darbuotojams",
    material: contentHygieneH10,
    questions: questionsHygieneH10,
    certificate: { fieldCode: "020", productCode: "H10", hours: "6 a.k." },
  },
  hygieneh10en: {
    title: "Hygiene training (H10) Training for food handlers",
    material: contentHygieneH10En,
    questions: questionsHygieneH10En,
    isEnglish: true,
    certificate: { fieldCode: "020", productCode: "H10", hours: "6 a.k." },
  },
  hygieneh11: {
    title: "Higienos mokymai (H11) Valymo paslaugas teikiantiems darbuotojams",
    material: contentHygieneH11,
    questions: questionsHygieneH11,
    certificate: { fieldCode: "021", productCode: "H11", hours: "6 a.k." },
  },
  hygieneh12: {
    title: "Higienos mokymai (H12) Skalbimą ir sausą (cheminį) valymą atliekantys darbuotojai",
    material: contentHygieneH12,
    questions: questionsHygieneH12,
    certificate: { fieldCode: "022", productCode: "H12", hours: "6 a.k." },
  },
  hygieneh13: {
    title: "Higienos mokymai (H13) Darbuotojai atsakingi už medicininių atliekų tvarkymą",
    material: contentHygieneH13,
    questions: questionsHygieneH13,
    certificate: { fieldCode: "023", productCode: "H13", hours: "6 a.k." },
  },
  hygieneh14: {
    title:
      "Higienos mokymai (H14) Darbuotojai, kurių veikla susijusi su žmogaus palaikų paslaugų teikimu",
    material: contentHygieneH14,
    questions: questionsHygieneH14,
    certificate: { fieldCode: "024", productCode: "H14", hours: "6 a.k." },
  },
  hygieneh15: {
    title: "Higienos mokymai (H15) Su nuodingosiomis medžiagomis dirbantys darbuotojai",
    material: contentHygieneH15,
    questions: questionsHygieneH15,
    certificate: { fieldCode: "H15", productCode: "H15", hours: "6 a.k." },
  },
  hygienehb: {
    title: "Higienos mokymai (HB) Bendroji higienos įgūdžių programa darbuotojams",
    material: contentHygieneHb,
    questions: questionsHygieneHb,
    certificate: {
      fieldCode: "000",
      productCode: "HB",
      hours: "2 a.k.",
      templatePath: "/certificatehb.pdf",
    },
  },
  hygienehben: {
    title: "Hygiene training (HB) General hygiene skills program",
    material: contentHygieneHbEn,
    questions: questionsHygieneHbEn,
    isEnglish: true,
    certificate: {
      fieldCode: "000",
      productCode: "HB",
      hours: "2 a.k.",
      templatePath: "/certificatehb.pdf",
    },
  },
  hygienehbb: {
    title: "Higienos mokymai (HBB) Netiesiogiai maistą tvarkantiems darbuotojams",
    material: contentHygieneHbb,
    questions: questionsHygieneHbb,
    certificate: { fieldCode: "020", productCode: "HBB", hours: "2 a.k." },
  },
} as const satisfies Record<string, ProductDefinition>;

export type ProductKey = keyof typeof PRODUCT_REGISTRY;

export const PRODUCT_OPTIONS = (
  Object.entries(PRODUCT_REGISTRY) as Array<[ProductKey, ProductDefinition]>
).map(([name, product]) => ({
  name,
  title: product.title,
}));

export const PRODUCT_KEYS = Object.keys(PRODUCT_REGISTRY) as ProductKey[];

export const isProductKey = (value: string): value is ProductKey => value in PRODUCT_REGISTRY;

export const getProductDefinition = (value: string): ProductDefinition | undefined =>
  isProductKey(value) ? PRODUCT_REGISTRY[value] : undefined;
